export default "__VITE_ASSET__CrvCHdAG__"